/**
 * @author  : 王冲
 * @desc    : passport -- iefix
 */
try {
    if (!window.location.origin) {
        const { protocol, hostname, port } = window.location;
        const origin = `${protocol}//${hostname}${port ? ':' + port : ''}`;
        // @ts-ignore 只读属性，无法赋值所以ignore
        window.location.origin = origin;
    }
    if (!String.prototype.hasOwnProperty("replaceAll")) {
        String.prototype.replaceAll = function (s1, s2) {
            return this.replace(new RegExp(s1, "gim"), s2 as string);
        };
    }
} catch (error) {
    console.error(error)
}
const IEfix = null;
export default IEfix